var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeryCriticalRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.186.5 2.977 2.977v4.21l-2.977 2.976h-4.21L0 7.686v-4.21L2.977.5h4.21zM5 7.387a.695.695 0 0 0-.707.712v.017c0 .403.301.712.707.712a.694.694 0 0 0 .707-.712v-.017A.694.694 0 0 0 5 7.387zm.397-4.5h-.796c-.22 0-.348.185-.325.428l.35 3.15c.024.225.17.368.374.368s.35-.14.374-.368l.35-3.148c.023-.244-.107-.428-.327-.43z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryCriticalRisk);
export default __webpack_public_path__ + "static/media/very-critical-risk.09b8b7466077f93c312b6cd593b35218.svg";
export { ForwardRef as ReactComponent };